module.exports = __webpack_public_path__ + "static/Liberty-5397d03931686c5d1d8ee31f0760cfe9.png";